import { render } from "./HeaderComponent.vue?vue&type=template&id=6873ee08&scoped=true&ts=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts"

import "./HeaderComponent.vue?vue&type=style&index=0&id=6873ee08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6873ee08"]])

export default __exports__